import { LocalizationLanguage } from '@gov-nx/core/app/localization/languages';
import { useUserStoreLanguage } from '@gov-nx/store/user/store';

interface AppLanguageSelector {
	language: LocalizationLanguage;
}

export const useAppLanguageSelector = (): AppLanguageSelector => {
	const language = useUserStoreLanguage();

	return { language: language ?? LocalizationLanguage.Czech };
};
